export default (state) => state.restricted.message.unread_messages;
